import cryptojsService from "../cryptojs.service";
import authService from "@/services/auth/auth.service";
import vue from "@/main";
import store from "@/store";

class UserService {
	static get SECRET() {
		return "+MbQeThWmZq4t7w!z%C*F)J@NcRfUjXn2r5u8x/A?D(G+KaPdSgVkYp3s6v9y$B&";
	}
	static get KEY() {
		return `WFL_APP_AUTH`;
	}
	getUserInfo() {
		let userInfo = null;
		try {
			let encrypted = localStorage.getItem(UserService.KEY);
			if (!encrypted) {
				return null;
			}
			userInfo = JSON.parse(
				cryptojsService.decrypt(encrypted, UserService.SECRET),
			);
			return userInfo;
		} catch (error) {
			console.log(error);
			return null;
		}
	}
	setUserInfo(userInfo) {
		try {
			localStorage.setItem(
				UserService.KEY,
				cryptojsService.encrypt(
					JSON.stringify(userInfo),
					UserService.SECRET,
				),
			);
		} catch (e) {
			console.log(e);
		}
	}
	async signOut() {
		try {
			await authService.logout();
		} catch (error) {
			console.error("signOut()", error);
		} finally {
			localStorage.clear();
			sessionStorage.clear();
			// Reset state người dùng để layout (sidebar) ẩn ngay, không cần F5.
			store.state.currentUserInfo = null;
			await vue.$router.replace({ name: "login" });
		}
	}

	async redirectUnauthorized(data) {
		return vue.$router.push({
			name: "unauthorized-redirect",
			params: { data },
		});
	}

	storeAppAuth(res) {
		try {
			this.setUserInfo(res);
			if (!localStorage.getItem(UserService.KEY)) {
				throw new Error("Failed to save APP_AUTH");
			}
			return Promise.resolve("saved");
		} catch (error) {
			return Promise.reject(error.message || "Failed to save tokens");
		}
	}

	async refreshTokenInternal() {
		try {
			return await authService.reLogin();
		} catch (error) {
			console.error("refreshTokenInternal()", error);
			return userService.redirectUnauthorized({
				error: "workflow.expired",
			});
		}
	}
}

const userService = new UserService();
export default userService;
